import "core-js/modules/es.array.reduce.js";
import AuthorsApi from '@/frontend/api/authors';
import setMetas from '@/frontend/functions/setMetas';
import WorkCardComponent from '@/frontend/components/WorkCardComponent';
export default {
  name: "AuthorPage",

  data() {
    return {
      Author: {},
      fullDesc: false,
      moreBlock: false,
      descSymbolMax: 1600
    };
  },

  components: {
    WorkCardComponent
  },
  watch: {
    $route() {
      this.$route.name === 'author' && this.init();
    }

  },
  computed: {
    dateLife() {
      let result = '(date)';
      if (!this.Author.year_life && !this.Author.year_death) return '';
      if (this.Author.year_life && this.Author.year_death) result = result.replace('date', this.Author.year_life + ' - ' + this.Author.year_death);else result = result.replace('date', this.Author.year_life || this.Author.year_death);
      return result;
    },

    description() {
      if (!this.Author.description) return [''];
      if (this.fullDesc) return this.Author.description.split('\r\n');
      return this.Author.description.length > this.descSymbolMax ? this.Author.description.slice(0, this.descSymbolMax).split('\r\n') : this.Author.description.split('\r\n');
    }

  },
  methods: {
    init() {
      AuthorsApi.get({
        expand: ['works', 'works.author'].join(',')
      }, this.$route.params.id).then(response => {
        this.Author = response;
        this.Author.works.forEach(value => {
          value.price = value.characteristics.reduce((old, next) => !old && next.name === 'Информация' ? next.name + ': ' + next.value : old, '');
        });
        this.moreBlock = this.Author.description && this.Author.description.length > this.descSymbolMax;
      }).catch(() => this.$router.push({
        name: 'not-found'
      }));
    }

  },

  created() {
    setMetas('author');
    this.init();
  }

};